












import Vue from "vue";
export default Vue.extend({
  props: {
    profile: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      document: [
        {
          text: "Locaciones para despachos",
          icon: "fas fa-map-marked-alt",
          to: { name: `dispatchLocation${this.profile}` },
        },
      ],
    };
  },
});
